import { Injectable } from '@angular/core';
import { LicenseAddQrCode } from './license-add-qr-code';
import { Observable } from 'rxjs';
import { Device } from '../api/device/models/device.interface';

@Injectable({ providedIn: 'root' })
export class LicenseAddStoreService {
  deviceSerial?: string;
  licenseAddQrCode?: LicenseAddQrCode;
  device$?: Observable<Device>;

  clean() {
    this.deviceSerial = undefined;
    this.licenseAddQrCode = undefined;
    this.device$ = undefined;
  }
}
